/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Maps a raw ID-token payload to the Redux claims copy. Leaf module: no
 * firebase import, so tests can inject a token payload at this exact seam.
 */

// boxRole and boxStatus stay raw on purpose: resolveBoxAccess decides on the
// PRESENCE of boxRole and on boxStatus; coercing either hands a stale `box`
// flag the win (same rule as the mobile adapter).
export const claimsFromIdToken = (raw) => ({
  admin: raw?.admin || false,
  lemonadeAdmin: raw?.lemonadeAdmin || false,
  box: raw?.box || false,
  coach: raw?.coach || false,
  boxCoach: raw?.boxCoach || false,
  athlete: raw?.athlete || true,
  role: raw?.role || "Athlete",
  accessLevel: raw?.accessLevel || 0,
  coachType: raw?.coachType || null,
  boxID: raw?.boxID || null,
  boxRole: raw?.boxRole ?? null,
  boxStatus: raw?.boxStatus ?? null,
});
